export interface CarFormProgressProps {
  step: number
}

export default function CarFormProgress({ step }: CarFormProgressProps) {
  return (
    <h2 className="text-heading-xs text-tertiary text-center">{step} / 4</h2>
  )
}
